import { render, staticRenderFns } from "./label-set.vue?vue&type=template&id=847f97d4&scoped=true&"
import script from "./label-set.vue?vue&type=script&lang=js&"
export * from "./label-set.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "847f97d4",
  null
  
)

export default component.exports